export const isSessionValid = () => {
    const loginTime = localStorage.getItem('loginTime');

    if (!loginTime) {
        return false;
    }

    const THIRTY_MINUTES = 30 * 60 * 1000;
    const diff = Date.now() - Number(loginTime);
    const expired = diff > THIRTY_MINUTES;

    if (expired) {
        localStorage.clear();
        return false;
    }

    return true;
};